const clinicCardButtonPosition = () => {
    const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
    if(document.querySelector('.clinic-card') && vw > 1200){
        const allCards = document.querySelectorAll('.clinic-card');
        allCards.forEach(card => {
            const rightColumn = card.querySelector('.ume-uke-clinic-card-right-column');
            const button = card.querySelector('.ume-uke-clinic-card-button');
            if(button !== null){
                const columnChildren = rightColumn.childNodes;

                let height = 16
                let undefinedCount = 0;
                if(columnChildren.length > 0){
                    for (let i = 0; i <  columnChildren.length; i++) {
                        let childHeight = columnChildren[i].clientHeight
                        if(childHeight !== undefined){
                            height = height + childHeight;
                        } else {
                            undefinedCount++
                        }

                    }
                }
                height = height + undefinedCount*15;
                button.style.top = height + 'px';

            }
        })
    }
}
export default  clinicCardButtonPosition;